const routers = [
   
    {
        path: '/content/News',
        name: 'ContentNews',
        component: resolve => require(['../views/content/News'], resolve)
    },
    {
        path: '/content/Document',
        name: 'Document',
        component: resolve => require(['../views/content/Document'], resolve)
    },
    {
        path: '/content/News/InsertNews',
        name: 'InsertNews',
        component: resolve => require(['../views/content/InsertNews'], resolve)
    },
    {
        path: '/content/News/NewsDesc',
        name: 'NewsDesc',
        component: resolve => require(['../views/content/NewsDesc'], resolve)
    },
   
    
]
export default routers



// WEBPACK FOOTER //
// ./src/routers/content.js